/* profile page will show info about admin like name email google Review link etc
as a form. so we need a loader to get data from DB, any change in the form will be 
saved in DB on clicking DB. 



    */

import domain from "../domain";
import {
  Form,
  Link,
  redirect,
  useActionData,
  useLoaderData,
  useNavigate,
} from "react-router-dom";
import PageContent from "../components/PageContent";
import classes from "./MyProfilePage.module.css";
import { isLoggedIn } from "../util/getToken";
import { useEffect, useRef, useState } from "react";
import StaffRegister from "../components/StaffRegister";
import MyInfoComponent from "../components/MyInfoComponent";
import ToggleSwitch from "../components/ToggleSwitch";
import ExternalRating from "../components/ExternalRating";
import OffersComponent from "../components/OffersComponent";

let data = [];
if(localStorage.getItem("pdata")) {
  data = JSON.parse(localStorage.getItem("pdata"));
} else {
  data = [];
}
 
//console.log(data);

//function to fetch profile data from DB

async function fetchProfileData() {
  if (!isLoggedIn()) return;
  try {
    const data1 = await fetch(`${domain}/api/profile`, {
      method: "Post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },

      // body: JSON.stringify({ _id:id }),
    });
    // const result = await data.json();
    // console.log("data from load form lazy loader");
    // console.log(result);
    const data = await data1.json();

    return data;
  } catch (err) {}
}

async function go() {
  try {
    //if pdata is  not present in local storage then fetch from DB

    const data = await fetchProfileData();

    localStorage.setItem("pdata", JSON.stringify(data));
  } catch (err) {}
}

export default function MyProfilePage() {
  const [fresh, setFresh] = useState(false);
  let pdata = JSON.parse(localStorage.getItem("pdata"));
 
  let externalReviewData = JSON.parse(localStorage.getItem("questions"))?.externalReview;
  
  let role = localStorage.getItem("role");
  // if (pdata == null || pdata == undefined) {
  //   console.log("flag");
  //   go();
  //   pdata = localStorage.getItem("pdata");
  // } else {
  //   console.log("flag2");
  //   pdata = JSON.parse(pdata);
  // }

  // console.log(result);

  const isLinkEdited = useRef(false);

  const navigate = useNavigate();
  const [link, setLink] = useState(data?.gReviewLink);

  //console.log(data);

  // function editFormHandler(e) {
  //   console.log("form handler hit");
  //   console.log(e.target.parentNode.lastChild.firstChild);
  //   let button = e.target.parentNode.lastChild.firstChild;
  //   button.hidden = false;
  //   button.innerHTML = "Save";
  //   // console.log(link);
  //   // console.log(e.target.name);
  //   if (e.target.name == "gReviewLink") {
  //     isLinkEdited.current = true;
  //     console.log(
  //       "g reivew link changed - value of isLinkedited - " +
  //         isLinkEdited.current
  //     );
  //     setLink(e.target.value);
  //   }
  // }

  function toggleHandler(status) {
    // we receive true or false from toggle button. as status

    // sending DB request to api to change status

    sendRequestToEnableRating(status);
  }

 
  function saveHandler(e) {
    e.target.innerHTML = "Saved";
    e.target.hidden = true;
  }

  useEffect(() => {
    if (pdata == null) {
      go();
      setFresh((p) => {
        return !p;
      });
    }
  }, []);
  return (
    <>
      {pdata?.message && <p>{pdata.message}</p>}

      <PageContent>
        <h1>Profile Page</h1>
        <div className={classes.outerContainer}>
          <div className={classes.subContainer}>
            <MyInfoComponent data={pdata} />
          </div>

          <div className={classes.subContainer}>
            <ExternalRating data={externalReviewData} />
          </div>
          {role === "hq" && (
            <div className={classes.subContainer}>
              <OffersComponent />
            </div>
          )}
          {/* <div className={classes.subContainer}>
            <h3>My Information</h3>
            <div className={classes.formContainer}>
              <Form
                method="post"
                readOnly={true}
                id="myForm"
                onChange={editFormHandler}
              >
                <label htmlFor="name">Name</label> <br></br>
                <input
                  type="text"
                  name="name"
                  defaultValue={pdata?.name}
                />{" "}
                <br></br>
                <br></br>
                <label htmlFor="phone">Phone Number</label> <br></br>
                <input type="text" name="phone" defaultValue={pdata?.phone} />
                <br></br>
                <br></br>
                <label htmlFor="">Google Review Link</label>
                <input
                  type="text"
                  name="gReviewLink"
                  defaultValue={pdata?.gReviewLink}
                />
                <button type="button" onClick={linkTestHandler}>
                  Test
                </button>
                <br></br>
                <input
                  type="hidden"
                  name="isLinkEdited"
                  value={isLinkEdited.current}
                />
                <div className={classes.buttonContainer}>
                  <button onClick={saveHandler}>Save</button>
                </div>
              </Form>
            </div>
          </div> */}

         
          {(role != "hq") ? <> <div className={classes.subContainer}>
            <h3>Staff</h3>
            <div className={classes.staffToggleContainer}>
              <ToggleSwitch
                label={"Enable Rating"}
                onChangeHandler={toggleHandler}
              ></ToggleSwitch>
            </div>
            <div>
              <StaffRegister />
            </div>
          </div></> : <> ll </>}
        </div>
      </PageContent>
    </>
  );
}

async function sendRequestToEnableRating(status) {
  // this function hits api to change status
  console.log("enable rating", status);

  let body = { staffRatingEnabled: status,
    hqRid: localStorage.getItem("hqRid"),
   };
  try {
    console.log("flag1");
    const data1 = await fetch(`${domain}/api/enablerating`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify(body),
    });
    console.log("flag2");
    const data = await data1.json();
    if (data.message == "done") {
      // making changed to local storage.
      let q = JSON.parse(localStorage.getItem("questions"));

      let updatedq = { ...q, staffRatingEnabled: status };
      localStorage.setItem("questions", JSON.stringify(updatedq));
    }

    //  return data;
  } catch (err) {
    console.log(err);
  }
}

// below is action for My inofrmation block form action.
export async function action({ request, params }) {
  // console.log("save hit");
  const data = await request.formData();
  const myData = {
    name: data.get("name"),
    gReviewLink: data.get("gReviewLink"),
    isLinkEdited: data.get("isLinkEdited"),
    phone: data.get("phone"),
  };
  if (myData.gReviewLink == "" || myData.gReviewLink.length < 5) {
    myData.gReviewLink = "NA";
  }

  try {
    const data1 = await fetch(`${domain}/api/profile`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify(myData),
    });
    localStorage.setItem("pdata", JSON.stringify(myData));
    const data = await data1.json();

    //  return data;
  } catch (err) {}
  return redirect("/myprofile");
}
